export default {
  header: "FloodWeather",
  view: "Home",
  weather: {},
};
